import { render, staticRenderFns } from "./DspPartnersTable.vue?vue&type=template&id=70e980af&"
import script from "./DspPartnersTable.vue?vue&type=script&lang=js&"
export * from "./DspPartnersTable.vue?vue&type=script&lang=js&"
import style0 from "./DspPartnersTable.vue?vue&type=style&index=0&id=70e980af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports